export default [
  {
    title: 'Tài khoản',
    group: 'apps',
    icon: 'manage_accounts',
    name: 'Profile',
    roleId: 1
  },
  {
    title: 'Thông báo',
    icon: 'notifications',
    name: 'NotificationList',
    roleId: 1
  },
  // {
  //   title: 'Logging',
  //   icon: 'history',
  //   name: 'SystemLogList',
  //   permissionKey: 'logging',
  //   roleId: 1
  // },
  {
    title: 'Khách hàng',
    icon: 'account_box',
    name: 'CustomerList',
    permissionKey: 'customer',
    roleId: 4,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail' }
    ]
  },
  {
    title: 'Thanh toán TN',
    group: 'thanh-toan',
    icon: 'payment',
    name: 'Payment',
    roleId: 1,
    items: [
      {
        title: 'Chờ thanh toán',
        name: 'PaymentPendingList',
        component: 'PaymentPendingList',
        roleId: 1,
        permissionKey: 'payment_pending'
      },
      {
        title: 'Lịch sử thanh toán',
        name: 'PaymentHistoryList',
        component: 'PaymentHistoryList',
        roleId: 1,
        permissionKey: 'payment_history'
      }
    ]
  },
  {
    title: 'Hàng TMĐT',
    group: 'hang-tmdt',
    icon: 'assignment',
    name: 'EcommercePackage',
    roleId: 1,
    items: [
      {
        title: 'Nhập kho TQ',
        name: 'StoreManager',
        component: 'StoreManager',
        roleId: 8,
        permissionKey: 'store_cn'
      },
      {
        title: 'Nhập kho VN',
        name: 'StoreManagerVN',
        component: 'StoreManagerVN',
        roleId: 16,
        permissionKey: 'store_vn'
      },
      {
        title: 'Mã vận đơn',
        name: 'SmallPackage',
        component: 'SmallPackage',
        roleId: 32,
        permissionKey: 'small_package'
      },
      {
        title: 'Không tên',
        name: 'Noname',
        component: 'Noname',
        roleId: 32,
        permissionKey: 'noname'
      },
      {
        title: 'Bao hàng',
        name: 'BigPackage',
        component: 'BigPackage',
        roleId: 64,
        permissionKey: 'big_package'
      },
      {
        title: 'Yêu cầu giao hàng',
        name: 'ExportReceipt',
        component: 'ExportReceipt',
        roleId: 128,
        permissionKey: 'export_receipt'
      },
      {
        title: 'Báo cáo sale',
        name: 'TmdtSalesDashboard',
        component: 'TmdtSalesDashboard',
        permissionKey: 'tmdt_sales_dashboard'
      },
      {
        title: 'Báo cáo bao hàng',
        name: 'bao-cao-bao-hang',
        component: 'bao-cao-bao-hang',
        permissionKey: 'bao_cao_bao_hang'
      },
      {
        title: 'Báo cáo xuất hàng',
        name: 'bao-cao-xuat-hang',
        component: 'bao-cao-xuat-hang',
        permissionKey: 'bao_cao_xuat_hang'
      }
    ]
  },
  {
    title: 'Hàng lô',
    group: 'hang-lo',
    icon: 'bar_chart',
    name: 'BatchPackage',
    roleId: 1,
    items: [
      {
        title: 'Nhập kho TQ',
        name: 'WuliuList',
        component: 'WuliuList',
        permissionKey: 'wuliu_list'
      },
      {
        title: 'Quản lý mã bốc',
        name: 'BatchPackageAll',
        component: 'BatchPackageAll',
        permissionKey: 'batch_package_all'
      },
      {
        title: 'Hàng không tên',
        name: 'UnnamedPackage',
        component: 'UnnamedPackage',
        permissionKey: 'unnamed_package',
        filterType: 'unnamed'
      },
      {
        title: 'Quản lý Xe',
        name: 'TruckList',
        component: 'TruckList',
        permissionKey: 'truck_list',
        children: [
          { name: 'TruckDetail', titleKey: 'truck_detail', title: 'Chi tiết xe', component: 'TruckDetail' }
        ]
      },
      {
        title: 'Xuất kho',
        name: 'BillList',
        component: 'BillList',
        permissionKey: 'bill_list',
        children: [
          { name: 'BillDetail', titleKey: 'bill_detail', title: 'Chi tiết xuất kho', component: 'BillDetail' }
        ]
      },
      {
        title: 'Báo cáo sale',
        name: 'SalesDashboard',
        component: 'SalesDashboard',
        permissionKey: 'sales_dashboard'
      },
      {
        title: 'Báo cáo lưu kho',
        name: 'StorageByBatchCodeReport',
        component: 'StorageByBatchCodeReport',
        permissionKey: 'storage_by_batch_code_report'
      },
    ]
  },
  {
    title: 'Hàng C.Ngạch',
    group: 'hang-chinh-ngach',
    icon: 'verified',
    name: 'OfficialGoods',
    roleId: 1,
    items: [
      {
        title: 'Quản lý đơn hàng',
        name: 'CnOrderList',
        component: 'CnOrderList',
        permissionKey: 'cn_order',
        children: [
          { name: 'CnOrderDetail', title: 'Chi tiết đơn hàng', component: 'CnOrderDetail' }
        ]
      },
      {
        title: 'Hàng hóa',
        name: 'CnProductList',
        component: 'CnProductList',
        permissionKey: 'cn_order'
      },
      {
        title: 'Mã vận đơn',
        name: 'CnWaybillList',
        component: 'CnWaybillList',
        permissionKey: 'cn_order'
      },
      {
        title: 'Quản lý khai báo',
        name: 'CnTruckList',
        component: 'CnTruckList',
        permissionKey: 'cn_truck',
        children: [
          { name: 'CnTruckDetail', title: 'Chi tiết khai báo', component: 'CnTruckDetail' }
        ]
      },
      {
        title: 'Giao hàng',
        name: 'CnDeliveryList',
        component: 'CnDeliveryList',
        permissionKey: 'cn_delivery',
        children: [
          { name: 'CnDeliveryDetail', title: 'Chi tiết lệnh giao', component: 'CnDeliveryDetail' }
        ]
      },
      {
        title: 'Quản lý tài chính',
        name: 'CnPaymentList',
        component: 'CnPaymentList',
        permissionKey: 'cn_payment'
      },
      {
        title: 'Báo cáo sale',
        name: 'CnSalesDashboard',
        component: 'CnSalesDashboard',
        permissionKey: 'cn_report'
      },
    ]
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'settings',
    name: 'Setting',
    permissionKey: 'setting',
    roleId: 256,
    items: [
      // {
      //   title: 'Kho nhận',
      //   name: 'StorageList',
      //   component: 'StorageList'
      // },
      {
        title: 'Phân quyền',
        name: 'PermissionMatrix',
        component: 'PermissionMatrix',
        permissionKey: 'setting'
      },
      {
        title: 'Nhật ký thao tác',
        name: 'AuditLogList',
        component: 'AuditLogList',
        permissionKey: 'setting'
      },
      {
        title: 'Loại hàng',
        name: 'ProductTypeList',
        component: 'ProductTypeList',
        permissionKey: 'setting'
      },
      // {
      //   title: 'Phí cân',
      //   name: 'FeeWeightList',
      //   component: 'FeeWeightList',
      //   permissionKey: 'setting'
      // },
      // {
      //   title: 'Phí khối',
      //   name: 'FeeVolumeList',
      //   component: 'FeeVolumeList',
      //   permissionKey: 'setting'
      // },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        component: 'StaffList',
        permissionKey: 'setting',
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ]
      },
      {
        title: 'Thiết lập dịch vụ',
        name: 'CnServiceList',
        component: 'CnServiceList',
        permissionKey: 'cn_service'
      },
      {
        name: 'Configuration',
        title: 'Cấu hình chung',
        component: 'Configuration',
        permissionKey: 'setting'
      }
    ]
  }
];
